/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ n: NonNullable<unknown> }} Pm_Duplicates_WarningInputs */

const cs_pm_duplicates_warning = /** @type {(inputs: Pm_Duplicates_WarningInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.n} nemovitostí je vybráno u více inzerátů – opravte to před uložením.`)
};

const en_pm_duplicates_warning = /** @type {(inputs: Pm_Duplicates_WarningInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.n} properties are picked for several listings – fix before saving.`)
};

/**
* | output |
* | --- |
* | "{n} properties are picked for several listings – fix before saving." |
*
* @param {Pm_Duplicates_WarningInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const pm_duplicates_warning = /** @type {((inputs: Pm_Duplicates_WarningInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pm_Duplicates_WarningInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pm_duplicates_warning(inputs)
	return cs_pm_duplicates_warning(inputs)
});